import type { QueryClient } from '@tanstack/react-query';

/** Refresh both the campaign summary and the independently cached settings form.
 * Await the reads so a subsequent save cannot send the pre-toggle flag. */
export async function refreshCampaignSettings(qc: QueryClient, base: string, campaignId: string) {
  await Promise.all([
    qc.invalidateQueries({ queryKey: ['campaigns'] }),
    ...['features', 'schedule', 'topup', 'stop-rules'].map((name) =>
      qc.invalidateQueries({ queryKey: [name, base, campaignId] }),
    ),
  ]);
}
